<template>
    <app-layout title="SOPs">
        <form @submit.prevent="handleSubmit">
            <page-header>
                <template #title>Edit SOP</template>
                <template #actions>
                    <jet-button v-show="form.isDirty" type="submit" class="leading-none" :disabled="form.processing" >
                        Save
                    </jet-button>

                    <jet-tertiary-button
                        v-if="form.isDirty"
                        :disabled="form.processing"
                        class="leading-none"
                        @click="showUnsavedChangesModal = true"
                    >
                        Cancel
                    </jet-tertiary-button>

                    <jet-tertiary-button
                        v-else
                        :disabled="form.processing"
                        :href="route('sops.index')"
                        class="leading-none"
                    >
                        Close
                    </jet-tertiary-button>
                </template>
            </page-header>
            
            <SopForm
                :form="form"
                :categories="categories"
                class="px-3 md:px-4 lg:px-8"
            />

            <div class="px-3 md:px-4 lg:px-8 py-4">
                <SopStepsEdit
                    :form="form"
                />
            </div>

            <div class="w-full text-center my-8">
                <jet-danger-button @click="showDeleteModal = true">Delete SOP</jet-danger-button>
            </div>
        </form>

        <unsaved-changes-modal-2
            :formRoute="formRoute"
            :isDirty="form.isDirty"
            :show="showUnsavedChangesModal"
            @close="showUnsavedChangesModal = false"
            @confirm="$inertia.get(route('sops.index'))"
        />

        <jet-confirmation-modal :show="showDeleteModal" @close="showDeleteModal=false">
            <template #title>
                Delete SOP
            </template>

            <template #content>
                Are you sure you would like to delete this SOP?
            </template>

            <template #footer>
                <jet-tertiary-button @click="showDeleteModal=false">
                    Cancel
                </jet-tertiary-button>

                <jet-danger-button class="ml-2" @click="deleteSop" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                    Delete
                </jet-danger-button>
            </template>
        </jet-confirmation-modal>
    </app-layout>
</template>

<script>
import { useForm } from '@inertiajs/inertia-vue3';
import AppLayout from '@/Layouts/AppLayout.vue';
import PageHeader from '@/Layouts/partials/PageHeader.vue';
import SopForm from '@/Pages/SOP/Partials/SopForm.vue';
import SopStepsEdit from '@/Pages/SOP/Partials/SopStepsEdit.vue';
import JetButton from '@/Jetstream/Button';
import JetTertiaryButton from '@/Jetstream/TertiaryButton';
import JetDangerButton from '@/Jetstream/DangerButton';
import JetConfirmationModal from '@/Jetstream/ConfirmationModal';
import UnsavedChangesModal2 from '@/Shared/UnsavedChangesModal2';

import '@vueform/multiselect/themes/default.css';
import '@vueform/toggle/themes/default.css';

export default {
    components: {
        AppLayout,
        PageHeader,
        SopForm,
        SopStepsEdit,
        JetButton,
        JetTertiaryButton,
        JetDangerButton,
        JetConfirmationModal,
        UnsavedChangesModal2,
    },

    setup(props) {
        const form = useForm({
            id: props.sop.id,
            category: props.sop.category,
            title: props.sop.title,
            description: props.sop.description,
            sop_steps: props.sop.sop_steps.map(step => {
                return {
                    id: step.id,
                    description: step.description,
                    uploads: step.uploads,
                    pendingImage: null,
                    previewImage: null,
                }
            })
        })

        return { form }
    },

    props: [
        'sop',
        'categories',
    ],

    data() {
        return {
            formRoute: this.route('sops.update.post', this.sop.id),
            showDeleteModal: false,
            showUnsavedChangesModal: false,
        }
    },

    methods: {
        handleSubmit () {
            if (!this.form.processing){
                this.form.post(route('sops.update.post', this.sop.id));
            }
        },

        deleteSop () {
            this.$inertia.delete(route('sops.destroy', this.sop.id), null, {
                onError: (errors) => {
                    console.log(errors);
                }
            });
        },
    }
}

</script>